module.exports = __webpack_public_path__ + "img/leaderboard.29499a1b.svg";